<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="box box-primary">
                        <div class="box-header text-center">
                            <h3 class="box-title">Выгрузка каталога в .csv файл</h3>
                        </div>
                        <div class="box-body pad table-responsive">
                            <table class="table table-bordered text-center">
                                <tr>
                                    <td>
                                        <button v-on:click="superGroups" type="button"
                                                class="btn btn-block btn-default">Категории
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <button v-on:click="groups" type="button" class="btn btn-block btn-default">
                                            Группы
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <button v-on:click="categories" type="button" class="btn btn-block btn-default">
                                            Подгруппы с описанием
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <button v-on:click="categoriesWithItems" type="button"
                                                class="btn btn-block btn-default">Подгруппы с товарами
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <button v-on:click="items" type="button" class="btn btn-block btn-default">
                                            Товары по подгруппам
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <button v-on:click="sellers" type="button" class="btn btn-block btn-default">
                                            Пользователи: Поставщики
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <button v-on:click="buyers" type="button" class="btn btn-block btn-default">
                                            Пользователи: Покупатели
                                        </button>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

    import UnloadingService from '../services/UnloadingService';


    const COMPONENT_NAME = 'unloading';

    export default {
        name: COMPONENT_NAME,
        data() {
            return {
            }
        },
        methods: {
            async superGroups() {
                let data = await UnloadingService.superGroups();
                this.csvExport(data.superGroups, data.name);
            },
            async groups() {
                let data = await UnloadingService.groups();
                this.csvExport(data.groups, data.name);
            },
            async categories() {
                let data = await UnloadingService.categories();
                this.csvExport(data.categories, data.name);
            },
            async categoriesWithItems() {
                let data = await UnloadingService.categoriesWithItems();
                this.csvExport(data.categoriesWithItems, data.name);
            },
            async items() {
                let data = await UnloadingService.items();
                this.csvExport(data.items, data.name);
            },
            async sellers() {
                let data = await UnloadingService.sellers();
                this.csvExportAssoc(data.sellers, data.name);
            },
            async buyers() {
                let data = await UnloadingService.buyers();
                this.csvExportAssoc(data.buyers, data.name);
            },

            csvExport(arrData, name) {
                let csvContent = "data:text/csv;charset=utf-8,";
                arrData.forEach(function(row){
                    // let row = rowArray.join(",");
                    csvContent += row + "\r\n";
                });
                const data = encodeURI(csvContent);
                const link = document.createElement("a");
                link.setAttribute("href", data);
                link.setAttribute("download", name + ".csv");
                link.click();
            },
            csvExportAssoc(arrData, name) {

                let csvContent = "data:text/csv;charset=utf-8,\uFEFF";
                for (const [key, value] of Object.entries(arrData)) {
                    let row = value.join("|");
                    csvContent += row + "\r\n";
                }
                const data = encodeURI(csvContent);
                const link = document.createElement("a");
                link.setAttribute("href", data);
                link.setAttribute("download", name + ".csv");
                link.click();
            },
        }
    }
</script>

<style scoped>

</style>